import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
      toast.success("If that email exists, a reset link is on its way.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-8">
      <div className="w-full max-w-sm" data-testid="forgot-password-page">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-brand-ink/50 hover:text-brand-red transition-colors mb-10"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
        <h1 className="font-display text-4xl">Reset password</h1>
        {sent ? (
          <p className="mt-4 text-brand-ink/60" data-testid="forgot-sent-msg">If an account exists for <strong>{email}</strong>, we've emailed a reset link. Check your inbox (and spam folder).</p>
        ) : (
          <>
            <p className="mt-3 text-brand-ink/60">Enter your email and we'll send you a link to reset your password.</p>
            <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-password-form">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@email.com" className="w-full rounded-xl border border-brand-line px-4 py-3 focus:ring-2 focus:ring-brand-red focus:outline-none" data-testid="forgot-email" />
              <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-brand-red text-white font-medium hover:bg-brand-reddark transition-colors disabled:opacity-60" data-testid="forgot-submit-btn">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Send reset link</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
